/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import StateMachineManager from '../../page-instructions/state-machine-manager';
import StateMachine from '../../page-instructions/state-machine/state-machine';
import constants, { publicConstants } from '../../constants';
import type { Action } from '../../store/state/state-manager';
import type { DxAPIResponseObject } from '../types';
import type { ActionPayload } from '../../refresh/types';
import Utils from '../../utils/utils';

export const generateInstructions = (
  context: string,
  pageReference: string,
  target: string,
  index: number,
  actionType: Action['type']
) => {
  if (actionType !== constants.RESOURCE_STATUS.CREATE) {
    return;
  }

  if (!StateMachineManager.isStateMachineExist(context, pageReference, target)) {
    StateMachineManager.setStateMachine(
      context,
      target,
      pageReference,
      new StateMachine(target, pageReference, context)
    );
  }
  const stateMachine = StateMachineManager.getStateMachine(context, pageReference, target);
  // index starts with 0 hence +1
  stateMachine.insert({}, typeof index === 'string' ? index : index + 1, true, { isDefault: true });
};

export const updateCaseInfoContentForPageGroup = (
  translatedDXAPIResponse: DxAPIResponseObject,
  index: string,
  subscriptFieldName: string,
  actionType: string,
  pageGroupName: string
) => {
  if (
    typeof index === 'string' &&
    translatedDXAPIResponse.data?.caseInfo?.content &&
    subscriptFieldName &&
    (actionType === 'CREATE' || actionType === 'UPDATE')
  ) {
    translatedDXAPIResponse.data.caseInfo.content[pageGroupName][index][subscriptFieldName] = index;
  }
};

export const getActionAndAssignmentID = (actionInPayload: ActionPayload) => {
  const isAssignmentAction = !actionInPayload.isLocalAction && actionInPayload.editType === constants.ACTION;
  return {
    ...(!isAssignmentAction ? { activeActionID: actionInPayload.actionID } : {}),
    assignments: [
      {
        ID: actionInPayload.assignmentID,
        ...(isAssignmentAction ? { actions: [{ ID: actionInPayload.actionID }] } : {})
      }
    ]
  };
};

export const updateClassIDInInitialContent = (
  initialContent: { [key: string]: string },
  pageReference: string,
  targetProperty: string,
  index: number,
  responseContent: { [key: string]: string }
) => {
  // if classID is not present in the initialContent, fetch it from the translatedDXAPIResponse
  if (!initialContent[constants.CLASSID]) {
    const path =
      pageReference === publicConstants.CASE_INFO.CASE_INFO_CONTENT
        ? `${targetProperty.replace('.', '')}[${index}].${constants.CLASSID}`
        : `${pageReference.split(publicConstants.CASE_INFO.CASE_INFO_CONTENT)[1].replace('.', '')}${targetProperty}[${index}].${constants.CLASSID}`;
    const classID = Utils.getIn(responseContent, path);
    if (classID) {
      initialContent[constants.CLASSID] = classID;
    }
  }
};

export default { generateInstructions, updateCaseInfoContentForPageGroup };
